// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__TI2Te","modal":"Modal_modal__iZYVK","slide-down":"Modal_slide-down__eROd7"};